import 'whatwg-fetch';
import { mapKeys, camelCase } from 'lodash';
import { csrfFromDom } from 'common/utils/server';

export const SET_CATEGORY_NAME = 'SET_CATEGORY_NAME';
export const CATEGORY_FORM_REQUEST = 'CATEGORY_FORM_REQUEST';
export const CATEGORY_FORM_ERROR = 'CATEGORY_FORM_ERROR';
export const CATEGORY_FORM_SUCCESS = 'CATEGORY_FORM_SUCCESS';

export function setCategoryName(value) {
  return { type: SET_CATEGORY_NAME, value };
}

function categoryFormRequest() {
  return { type: CATEGORY_FORM_REQUEST };
}
function categoryFormSuccess(category) {
  return { type: CATEGORY_FORM_SUCCESS, category };
}
function categoryFormError() {
  return { type: CATEGORY_FORM_ERROR };
}

export function createCategory(categoryName) {
  const categoryRequest = {
    name: categoryName,
  };
  return function fetchData(dispatch) {
    dispatch(categoryFormRequest());

    return fetch('/api/v1/coaching/takeaway_category', {
      method: 'POST',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfFromDom(),
      },
      body: JSON.stringify(categoryRequest),
    })
      .then(response => response.json())
      .then(json => {
        const categoryResponse = mapKeys(json, (_, key) => camelCase(key));

        dispatch(categoryFormSuccess(categoryResponse));
        dispatch(setCategoryName(''));
      })
      .catch(error => {
        dispatch(categoryFormError(error));
      });
  };
}
